import React, { useEffect, useRef, useState, useLocation } from 'react';
import EditServiceView from '../../views/PartnerView/EditServiceView';
import EditServiceDetails from '../../views/PartnerView/EditServiceDetails';
import { useParams } from 'react-router-dom';
import {useServiceContext} from '../../components/Context/ServiceContext';
import { usePartnerContext } from '../Context/PartnerContext';
import EmployeeDetailsView from '../../views/PartnerView/EmployeeDetailsView';
import EmployeEditForm from '../../views/PartnerView/EmployeeEditForm';

const EmployeeEditComponent = () => {
        const {id, edit} = useParams();
    const didFetch = useRef(false);
    const [loading, setLoading] = useState(true);

    const { updatedembployee,GetEmployeeByID } = usePartnerContext();
    const fetchData = async () => {
        try {
            await GetEmployeeByID(id);
             
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            fetchData();
            didFetch.current = true;
        }
    });
    
    return (
    <div>
    {/* {loading && <div>Loading...</div>}*/}
     {!loading  &&  edit == "false" && updatedembployee!=null && <EmployeeDetailsView />}
     {!loading  &&  edit == "true" && updatedembployee!=null && <EmployeEditForm  />}
    </div>
    // <div>
    //     {edit == "true" && <EditServiceView />}
    //     {edit == "false" && <EditServiceDetails  />}
    // </div>
    );
   
};

export default EmployeeEditComponent;
